var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_vm.loading)?_c('div',[_c('ck-header-background',{attrs:{"merchant-config":_vm.merchantConfig}}),_c('div',[_c('ck-header',{attrs:{"merchant-cfg":_vm.merchantConfig,"home-redirect":false,"show-profile":false}}),_c('ck-mobileapp-registration-form',{attrs:{"merchant-config":_vm.merchantConfig}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }